class ReactFilterPersonOwner extends React.Component {

    constructor(props) {
        super(props);
    }

    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {
        return {
            person_id:this.refs.combo.getValues()
        };
    }
    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.refs.combo.clearValues()
    }

    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        if(values.person_id){
            this.refs.combo.setValues({
                value:values.person_id
            })
        }else{
            this.clearValues();
        }
    }
    render() {
        var personId = '';

        if(this.props.settings.person_id){
            personId = this.props.settings.person_id
        }else if(parseInt(this.props.settings.logged_in_person)){
            personId = SS.vars.Person.id;
        }

        return React.createElement(ReactFilterCombo,{
            ref:'combo',
            label: this.props.label,
            url: SS.route('People','People','getAll'),
            value:personId,
            paginated:true,
            idField:'id',
            minChars:this.props.settings.min_chars,
            urlParams:{
                limit:10,
                simple:true
            },
            applyFilters: this.props.applyFilters,
            clearFilters: this.props.clearFilters,
            loadGrid: this.props.loadGrid
        });
    }
}

ReactFilterPersonOwner.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.object,
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func
};